import { useListType } from 'Stores/ListStore/ListStore';
import { LIST_TYPES } from 'Utilities/consts';

import { OPTIMIZELY_EVENTS } from '../optimizely.consts';

import { useTrackEventWhenReady } from './useTrackEventWhenReady';

interface UseTriggerSortOrderChangedFromRecommendedCallbackProps {
	currentSortOrder: string;
	newSortOrder: string;
}

type UseTriggerSortOrderChangedFromRecommended = ({
	currentSortOrder,
	newSortOrder,
}: UseTriggerSortOrderChangedFromRecommendedCallbackProps) => void;

export const useTriggerSortOrderChangedFromRecommended = (): UseTriggerSortOrderChangedFromRecommended => {
	const track = useTrackEventWhenReady(OPTIMIZELY_EVENTS.RECOMMENDED_SORT_ORDER_BOUNCE_RATE);
	const listType = useListType();

	return ({ currentSortOrder, newSortOrder }) => {
		const isLiveSaleTab = listType === LIST_TYPES.auction;
		const hasChangedFromRecommendedSortOrder =
			currentSortOrder === 'recommended-DESC' && newSortOrder !== 'recommended-DESC';

		track({
			condition: isLiveSaleTab && hasChangedFromRecommendedSortOrder,
		});
	};
};
